<div fxLayout="column" class="background" fxLayoutAlign="start center">
  <div fxFlex="75">
    <!-- Título -->
    <section id="header">
      <h1 class="h1Header">LISTADO DE ENVÍOS</h1>
    </section>

    <!-- Filtros -->
    <mat-card class="filter-card">
      <form (ngSubmit)="onSubmitFilters()" class="filter-form">
        
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Desde</mat-label>
            <input
              matInput
              [matDatepicker]="pickerFrom"
              [(ngModel)]="filterDateFrom"
              name="filterDateFrom"
            />
            <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
            <mat-datepicker #pickerFrom></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Hasta</mat-label>
            <input
              matInput
              [matDatepicker]="pickerTo"
              [(ngModel)]="filterDateTo"
              name="filterDateTo"
            />
            <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
            <mat-datepicker #pickerTo></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Estado</mat-label>
            <mat-select [(ngModel)]="filterStatus" name="filterStatus">
              <mat-option *ngFor="let status of statusOptions" [value]="status.value">
                {{ status.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Cadete</mat-label>
            <mat-select [(ngModel)]="filterCadete" name="filterCadete">
              <mat-option [value]="null">Todos los cadetes</mat-option>
              <ng-container *ngIf="Array.isArray(cadetes)">
                <mat-option *ngFor="let cadete of cadetes" [value]="cadete?.cdDelivery">
                  {{ cadete?.dsName || 'Sin nombre' }} ({{ cadete?.dsPhone || 'Sin teléfono' }})
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Cliente</mat-label>
            <input
              matInput
              [(ngModel)]="filterRecipientName"
              name="filterRecipientName"
              placeholder="Buscar por cliente"
            />
          </mat-form-field>
        

         <button
            mat-stroked-button
            color="accent"
            type="button"
            (click)="clearFilters()"
            class="filter-btn"
          >
            Limpiar
          </button>
          <button
            mat-raised-button
            color="primary"
            type="submit"
            class="filter-btn"
          >
            Filtrar
          </button>
       
      </form>
    </mat-card>

    <!-- Tabla -->
    <mat-card class="mat-elevation-z0" style="margin-top: 24px">
      <table *ngIf="Array.isArray(dataSource)" mat-table [dataSource]="dataSource" class="tabla">
        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef class="table-header" style="text-align: center;">Fecha</th>
          <td mat-cell *matCellDef="let element" class="table-content" style="text-align: center;">
            {{ element?.createdAt | argentinaDateTime }}
          </td>
        </ng-container>

        <ng-container matColumnDef="delivery">
          <th mat-header-cell *matHeaderCellDef class="table-header" style="text-align: center;">Cadete</th>
          <td mat-cell *matCellDef="let element" class="table-content" style="text-align: center;">
            {{ element?.assignedDeliveryName ? ( element.assignedDeliveryName + "("+ element.assignedDeliveryPhone +")") : "-"}}
          </td>
        </ng-container>

        <ng-container matColumnDef="client">
          <th mat-header-cell *matHeaderCellDef class="table-header" style="text-align: center;">Cliente</th>
          <td mat-cell *matCellDef="let element" class="table-content" style="text-align: center;">
            {{ element?.recipientName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="calculatedCost">
          <th mat-header-cell *matHeaderCellDef class="table-header" style="text-align: center;">Costo</th>
          <td mat-cell *matCellDef="let element" class="table-content" style="text-align: center;">
            {{ (element?.finalCostWithIVA != null ? element.finalCostWithIVA : (element?.finalCost != null ? element.finalCost : element?.calculatedCost)) | currency }}
          </td>
        </ng-container>

        <ng-container matColumnDef="scheduledAt">
          <th mat-header-cell *matHeaderCellDef class="table-header" style="text-align: center;">Programada</th>
          <td mat-cell *matCellDef="let element" class="table-content" style="text-align: center;">
            {{ element?.scheduledAt | argentinaDateOnly }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef class="table-header" style="text-align: center;">Estado</th>
          <td mat-cell *matCellDef="let element" class="table-content" style="text-align: center;">
            {{ getStatusLabel(element?.status) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="table-header" style="text-align: center;">Acciones</th>
          <td mat-cell *matCellDef="let element" class="table-content" style="text-align: center;">
            <div style="display: flex; justify-content: center; gap: 4px;">
              <button mat-icon-button color="accent" (click)="onViewOrder(element)" matTooltip="Ver">
                <mat-icon>visibility</mat-icon>
              </button>
              <button mat-icon-button color="primary" (click)="onEditOrder(element)" matTooltip="Editar">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="onDeleteOrder(element)" matTooltip="Eliminar" [disabled]="element?.status !== 0 && element?.status !== 1">
                <mat-icon>delete</mat-icon>
              </button>
              <button mat-icon-button color="primary" (click)="onAssignCadet(element)" matTooltip="Asignar cadete" [disabled]="element?.status !== 1 && element?.status !== 4">
                <mat-icon>person</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </table>

      <mat-paginator
        [length]="totalCount"
        [pageSize]="pageSize"
        [pageIndex]="pageNumber - 1"
        [pageSizeOptions]="pageSizeOptions"
        [showFirstLastButtons]="true"
        (page)="onPageChange($event)"
      ></mat-paginator>
    </mat-card>
  </div>
</div>
